<template>
    <code class="kbd">{{ text }}</code>
</template>

<script>
export default {
    name: 'Kbd',
    props: {
        text: {
            type: String,
            required: true
        }
    }
}
</script>

<style scoped>
.kbd {
    border-radius: 3px;
    background-color: #e0e0e0;
    color: var(--color-dark-gray);
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.2);
    display: inline-block;
    font-family: Arial,Helvetica,sans-serif;
    font-size: 10px;
    line-height: 1;
    padding: 2px 4px;
    white-space: nowrap;
    vertical-align: text-bottom;
}
</style>